export const CONTACT = {
  SUPPORT_EMAIL: 'support@mezzapay.com',
  SUPPORT_PHONE: '+971 565599608', // TODO MVP: Kevin to provide phone number
} as const 